module.exports = __webpack_public_path__ + "static/media/p1_8.af8aab3d.png";